import { Card } from "@/components/ui/card";
import { useUserJourney } from "@/hooks/useUserJourney";
import { Skeleton } from "@/components/ui/skeleton";
import { Trophy, TrendingUp, MessageSquare } from "lucide-react";

const AFFIRMATIONS = [
  "You're making great progress on your journey!",
  "Every step forward is a victory worth celebrating.",
  "Your commitment to growth is inspiring.",
  "You have the strength to handle whatever comes your way.",
  "Your resilience is remarkable.",
];

const UserJourney = () => {
  const { journeyData, isLoading } = useUserJourney();

  const getRandomAffirmation = () => {
    return AFFIRMATIONS[Math.floor(Math.random() * AFFIRMATIONS.length)];
  };

  const getMoodEmoji = (score: number) => {
    if (score >= 4) return "😊";
    if (score >= 3) return "🙂";
    if (score >= 2) return "😐";
    return "🤗";
  };

  if (isLoading) {
    return (
      <Card className="p-6 space-y-4">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-24 w-full" />
      </Card>
    );
  }

  return (
    <Card className="p-6 space-y-6">
      <div className="space-y-2">
        <h3 className="text-2xl font-semibold">Your Journey</h3>
        <p className="text-muted-foreground">{getRandomAffirmation()}</p>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        <Card className="p-4 flex flex-col items-center text-center space-y-2">
          <Trophy className="h-8 w-8 text-primary" />
          <h4 className="font-semibold">Weekly Progress</h4>
          <p className="text-4xl">
            {getMoodEmoji(journeyData?.mood_average || 0)}
          </p>
          <p className="text-sm text-muted-foreground">
            Average Mood: {journeyData?.mood_average?.toFixed(1) || "No data"}
          </p>
        </Card>

        <Card className="p-4 flex flex-col items-center text-center space-y-2">
          <TrendingUp className="h-8 w-8 text-primary" />
          <h4 className="font-semibold">Improvement</h4>
          <p className="text-4xl">
            {journeyData?.mood_improvement > 0 ? "📈" : "📊"}
          </p>
          <p className="text-sm text-muted-foreground">
            {journeyData?.mood_improvement > 0
              ? `${journeyData.mood_improvement.toFixed(1)}% better`
              : "Keeping steady"}
          </p>
        </Card>

        <Card className="p-4 flex flex-col items-center text-center space-y-2">
          <MessageSquare className="h-8 w-8 text-primary" />
          <h4 className="font-semibold">Achievements</h4>
          <p className="text-4xl">🏆</p>
          <p className="text-sm text-muted-foreground">
            {journeyData?.achievements?.length || 0} milestones reached
          </p>
        </Card>
      </div>

      {journeyData?.reflections && (
        <Card className="p-4 space-y-2">
          <h4 className="font-semibold">Weekly Reflection</h4>
          <p className="text-sm text-muted-foreground">{journeyData.reflections}</p>
        </Card>
      )}
    </Card>
  );
};

export default UserJourney;